
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cluster/[id]",
      function () {
        return require("private-next-pages/cluster/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cluster/[id]"])
      });
    }
  